<template>
  <div>
    <b-table striped hover :items="items" :fields="fields">
      <template v-slot:cell(name)="row">
        <b-form-input v-model="row.item.name" :readonly="!editMode"/>
      </template>
      <template v-slot:cell(wert)="row">
        <b-form-input type="number" :readonly="!editMode" v-model="row.item.wert" step="0.1"/>
      </template>
    </b-table>
    <div class="pb-3 float-right">
    <b-button :disabled="!editMode" @click="addRow()" size="sm" variant="light" class="pill"><i class="bi bi-plus"></i></b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditableTable',
  props: ['user', 'items', 'editMode'],
  methods: {
    addRow () {
      this.items.push({name: '', wert: 0})
    }
  },
  data () {
    return {
      fields: [{key: 'name', label: 'Name'}, {key: 'wert', label: 'Wert'}]
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/EditableTable.vue